import { STORIES } from "@/mocks/stories";
import { COLUMNS } from "@/mocks/site";
import type { ColumnItem } from "@/mocks/site";

export function columnBySlug(slug: string): ColumnItem | undefined {
  return COLUMNS.find((c) => c.slug === slug);
}

export function columnName(slug: string): string {
  const found = COLUMNS.find((c) => c.slug === slug);
  return found ? found.name : "吃瓜栏目";
}

export function storiesOfColumn(slug: string) {
  return STORIES.filter((s) => s.column === slug);
}

export function getStory(slug: string) {
  return STORIES.find((s) => s.slug === slug);
}

export function relatedStories(slug: string, currentSlug?: string, n = 3) {
  const same = STORIES.filter((s) => s.column === slug && s.slug !== currentSlug);
  if (same.length >= n) return same.slice(0, n);
  const others = STORIES.filter((s) => s.column !== slug && s.slug !== currentSlug);
  return [...same, ...others].slice(0, n);
}

export function hotStories(n = 5) {
  return [...STORIES].sort((a, b) => b.heat - a.heat || b.views - a.views).slice(0, n);
}

export function latestStories(n?: number) {
  const list = [...STORIES].sort((a, b) => (a.date < b.date ? 1 : -1));
  return n ? list.slice(0, n) : list;
}

export function formatCount(num: number): string {
  if (num >= 10000) {
    const w = num / 10000;
    return `${w % 1 === 0 ? w : w.toFixed(1)}万`;
  }
  return `${num}`;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const FAQ_ITEMS: FaqItem[] = [
  {
    q: "大学吃瓜的内容都来自哪里？",
    a: "我们的内容主要来自网友的匿名投稿以及各高校公开社交平台上已可公开检索的信息，经编辑整理后以故事化方式呈现，仅供娱乐交流，不对真实性作任何保证。",
  },
  {
    q: "在栏目里看到疑似自己的故事怎么办？",
    a: "如您发现内容涉及您本人且希望处理，可通过页面底部的联系邮箱向我们反馈，我们会第一时间核实并尽快下架相关条目，切实保护当事人隐私。",
  },
  {
    q: "吃瓜时需要遵守哪些基本底线？",
    a: "理性吃瓜、拒绝网暴是我们的第一原则。请大家不要对故事中涉及的个人进行人肉搜索、恶意评论或传播未经证实的隐私信息，也请勿因娱乐内容影响现实生活。",
  },
  {
    q: "网站多久更新一次新瓜？",
    a: "我们坚持天天更新。编辑团队每天 08:00 至 24:00 滚动整理并发布最新内容，热门故事会同步进入首页热度排行榜。",
  },
  {
    q: "我可以投稿自己身边的校园故事吗？",
    a: "欢迎投稿。您可以通过网站底部的联系邮箱向我们匿名投稿，请尽量提供事件的大致经过与背景，编辑会对内容进行脱敏处理后择优选发。",
  },
];